module.exports = __webpack_public_path__ + "img/iwona.e21bf3f5.jpg";